import { Component, Inject, EventEmitter, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { OverlayContainer } from '@angular/cdk/overlay';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { MatButton, MatAnchor } from '@angular/material/button';

@Component({
    selector: 'app-swap-day-cut-off-dialog',
    templateUrl: './swap-day-cut-off-dialog.component.html',
    styleUrls: ['./swap-day-cut-off-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogActions, MatButton, MatAnchor]
})
export class SwapDayCutOffDialogComponent {
  @Output() confirm: EventEmitter<boolean> = new EventEmitter();
  private subscription: Subscription;
  titleClass: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
    public overlayContainer: OverlayContainer,
    public breakpointObserver: BreakpointObserver
  ) {
    overlayContainer.getContainerElement().classList.remove('mini-calendar-dialog_overlay');
    overlayContainer.getContainerElement().classList.add('swap-day-dialog_overlay');
  }

  ngOnInit(): void {
    this.subscription = this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.Tablet
    ]).subscribe(result => {
      if (result.matches) {
        this.setMobileLayout();
      } else {
        this.setDesktopLayout();
      }
    });
  }

  cancelService() {
    this.dialogRef.close();
    this.confirm.emit(true);
  }

  closeDialog() {
    this.dialogRef.close();
    this.confirm.emit(false);
  }

  setMobileLayout() {
    this.titleClass = 'mat-headline u-margin-bottom-15';
    this.dialogRef.updateSize('343px', '288px');
  }

  setDesktopLayout() {
    this.titleClass = 'mat-display-small';
    this.dialogRef.updateSize('377px');
  }

  ngOnDestroy() {
    this.overlayContainer.getContainerElement().classList.remove('swap-day-dialog_overlay');
    this.subscription.unsubscribe();
  }
}
